import funds from './data-to-remove-isins.json'

const formatedFunds = funds.map(fund => {
  if (fund?.amount) return fund
  return { ...fund, amount: 10000 }
})

const getDefaultState = () => {
  return {
    list: formatedFunds.slice(0, 5)
  }
}

const state = getDefaultState()

const getters = {
  getTotalAmount: state => {
    let total = 0
    state.list.map(fund => {
      return (total = total + fund.amount)
    })
    return total
  },

  getTotalCustomer: state => {
    let total = 0
    state.list.map(fund => {
      return (total = total + fund.customerNumbers)
    })
    return total
  }
}

export default () => ({
  namespaced: true,
  state,
  getters
})
